export default "__VITE_ASSET__BmFX1$qh__"